import type { GetRequestsByUserIdResponse } from "@nlc/shared-types";

import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { profileKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

export function useGetRequestsByUserId(
  userId: number | string,
): UseQueryResult<GetRequestsByUserIdResponse> {
  return useQuery<GetRequestsByUserIdResponse>({
    queryFn: async () =>
      apiClient
        .url(`/users/${userId}/requests`)
        .get()
        .json<GetRequestsByUserIdResponse>(),
    queryKey: profileKeys.requestsByUserId(userId),
    refetchOnWindowFocus: false,
  });
}
